import axios from '../axiosConfig';

export default {
  login: request => axios.post('/api/user/login', request).then(response => response.data),
  impersonate: request=> axios.post('/api/user/impersonate', request).then(response=> response.data),
  validateToken: request => axios.post('/api/user/validateToken', request).then(response => response.data),
  acceptTerms: (paramsPayload) => axios.get('/api/user/acceptTerms', {
    params: paramsPayload
  }).then(response => response.data),
  changePassword: request => axios.post('/api/user/changePassword', request).then(response => response.data),
  resetPassword: request => axios.post('/api/user/resetPassword', request).then(response => response.data),
};